import { PropsWithChildren, ReactNode } from "react";

import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { ServiceDto } from "@apiModels/ServiceDto.csharp";
import { ServiceGroupDto } from "@apiModels/ServiceGroupDto.csharp";
import { SpecializationDto } from "@apiModels/SpecializationDto.csharp";
import { AppointmentDto } from "@apiModels/AppointmentDto.csharp";
import { UseFormGetValues, UseFormRegister } from "react-hook-form";

export type RootDataType = {
  specializations: SpecializationDto[];
  services: ServiceDto[];
  serviceGroups: ServiceGroupDto[];
  centers: LocationDto[];
  doctors: DoctorDto[];
};

export enum FieldsTypesEnum {
  "input" = "input",
  "textarea" = "textarea",
  "checkbox" = "checkbox",
  "options" = "options",
}

export enum FieldErrorPosition {
  "left" = "left",
  "bottom" = "bottom",
}

export enum FieldsSize {
  "fullWidth" = "fullWidth",
  "halfWidth" = "halfWidth",
  "twoThirdsWidth" = "twoThirdsWidth",
  "oneThirdWidth" = "oneThirdWidth",
}

export type ThirdStepFieldType = {
  label: string;
  type: FieldsTypesEnum;
  display?: boolean;
  required?: boolean;
  size?: FieldsSize;
  children?: ReactNode;
  optionsProps?: {
    options: string[];
    preSelectedFirst: boolean;
  };
};

export type ThirdStepFieldProps = PropsWithChildren<{
  label: string;
  name: string;
  error: any;
  register: UseFormRegister<FromThirdStepData>;
  getValues: UseFormGetValues<FromThirdStepData>;
  required?: boolean;
  size?: FieldsSize;
  optionsProps?: {
    options: string[];
    preSelectedFirst: boolean;
  };
}>;

export type ThirdStepFieldsEntries = {
  [key: string]: ThirdStepFieldType;
};

export type FromThirdStepData = {
  mobileNumber: number;
  personalIdNumber: number;
  parentPersonalIdNumber: number;
  name: string;
  firstName: string;
  lastName: string;
  city: string;
  emailAddress: string;
  notes: string;
  subscribeToNewsletter: boolean;
  terms: boolean;
  consent: boolean;
  remoteContact?: string;
  preparationRequirements: boolean;
  doctorPreparationRequirements: boolean;
};

export type TimesEntry = {
  appointments: AppointmentDto[];
  label: string;
  nextAvailableDate: Date | undefined;
  nextAvailableDateLabel: string;
};

export type Times = {
  [key: string]: TimesEntry;
};
